module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "page-title"
  }, [_vm._v("Order Saved as Pending")]), _vm._v(" "), _c('div', {
    staticClass: "g-my-20"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n            Your order has been saved as a pending order. To continue to edit this order,\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v("go to the Track Order page.")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15fe8fb8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fe8fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderPending.vue
// module id = 481
// module chunks = 4